import { HeaderTwoColumnLayoutSkeleton } from 'layouts';

const GivingDetailSkeleton = () => (
  <HeaderTwoColumnLayoutSkeleton
    header={{ paragraph: { rows: 6 } }}
    left={[{ paragraph: { rows: 2 } }, { paragraph: { rows: 6 } }]}
    right={[{ paragraph: { rows: 2 } }]}
  />
);

export default GivingDetailSkeleton;
